var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"session-management-list",attrs:{"screenConfig":_vm.setScreenConfig,"persistenceKey":'session-management-list',"loadDataGrid":_vm.loaded,"backButtonEnable":true,"backButtonRoute":'/settings/user'}})
}
var staticRenderFns = []

export { render, staticRenderFns }